export const MenuItems = () => [
  {
    moduleName: "Dashboard",
    orderNo: 1,
    url: "/dashboard",
    roles: ["Admin", "Police", "Advocate"],
  },

  {
    moduleName: "User Management",
    orderNo: 2,
    url: null,
    roles: ["Admin"],
    subMenu: [
      {
        moduleName: "Users",
        orderNo: 1,
        url: "/users",
        roles: ["Admin"],
      },
      {
        moduleName: "Password Reset",
        orderNo: 2,
        url: "/pr",
        roles: ["Admin"],
      },
    ],
  },

  {
    moduleName: "Configuration",
    orderNo: 3,
    url: null,
    roles: ["Admin"],
    subMenu: [
      {
        moduleName: "Documents",
        orderNo: 1,
        url: "/documents",
        roles: ["Admin"],
      },
      {
        moduleName: "Police Stations",
        orderNo: 2,
        url: "/p-s",
        roles: ["Admin"],
      },
      {
        moduleName: "Police Posts",
        orderNo: 3,
        url: "/posts",
        roles: ["Admin"],
      },
    ],
  },

  {
    moduleName: "Case Management",
    orderNo: 4,
    url: null,
    roles: ["Admin", "Police", "Advocate"],
    subMenu: [
      // Police
      {
        moduleName: "Create Case",
        orderNo: 1,
        url: "/ereply",
        roles: ["Police"],
      },
      {
        moduleName: "Cases Status",
        orderNo: 2,
        url: "/ers",
        roles: ["Police"],
      },

      // Advocate
      {
        moduleName: "View Requests",
        orderNo: 3,
        url: "/r-er",
        roles: ["Advocate"],
      },
      {
        moduleName: "Accepted Cases",
        orderNo: 4,
        url: "/a-er",
        roles: ["Advocate"],
      },

      // Admin
      {
        moduleName: "Sent by Police",
        orderNo: 5,
        url: "/erm",
        roles: ["Admin"],
      },
      {
        moduleName: "Assigned to Advocate",
        orderNo: 6,
        url: "/m-er",
        roles: ["Admin"],
      },
    ],
  },

  // ================= PAYMENT =================
  {
    moduleName: "Payments",
    orderNo: 5,
    url: null,
    roles: ["Admin"],
    subMenu: [
      {
        moduleName: "Retainership",
        orderNo: 1,
        url: "/rp",
        roles: ["Admin"],
      },
    ],
  },

  // ================= REPORTS =================
  {
    moduleName: "Reports",
    orderNo: 6,
    url: null,
    roles: ["Admin", "Police", "Advocate"],
    subMenu: [
      { 
        moduleName: "District Report",
        orderNo: 1,
        url: "/dr",
        roles: ["Admin"],
      },
      {
        moduleName: "Advocates Report",
        orderNo: 2,
        url: "/lor",
        roles: ["Admin", "Advocate"],
      },
      {
        moduleName: "Under Section Report",
        orderNo: 3,
        url: "/usr",
        roles: ["Admin", "Police"],
      },
      {
        moduleName: "Police Station Wise Report",
        orderNo: 4,
        url: "/pswr",
        roles: ["Admin"],
      }
    ],
  },
];